module.exports = __webpack_public_path__ + "static/ClickedFlightIssue-429612693cb85978b34c195d69155d57.png";